export const educationData = [
  {
    id: 1,
    institution: "RGPV, Bhopal",
    course: "Master Of Computor Application(MCA)",
    startYear: "September 2023",
    endYear: "Present",
  },
  {
    id: 2,
    institution: "Masai School",
    course: "Full Stack Developer",
    startYear: "March 2022",
    endYear: "February 2023",
  },
  {
    id: 3,
    institution: "Wazirganj College, Wazirganj",
    course: "Bachelor in Mathematics",
    startYear: "2016",
    endYear: "2019",
  },
  {
    id: 4,
    institution: "Mahavir Inter College, Gaya",
    course: "12th In PCM",
    startYear: "2012",
    endYear: "2015",
  },
];
